module.exports = __webpack_public_path__ + "img/home_active.386d2ad5.svg";